/** Lao labels for hotel cancellation policies, fees and reasons. */
export const laoHotelCancellation: Record<string, string> = {
  'Cancellation policies': 'ນະໂຍບາຍການຍົກເລີກ',
  'Cancellation policy': 'ນະໂຍບາຍການຍົກເລີກ',
  'Define what guests pay when they cancel or do not arrive. Each reservation keeps the terms it was booked with.':
    'ກຳນົດຄ່າທຳນຽມທີ່ແຂກຕ້ອງຈ່າຍເມື່ອຍົກເລີກ ຫຼື ບໍ່ມາເຂົ້າພັກ. ແຕ່ລະການຈອງຈະໃຊ້ເງື່ອນໄຂທີ່ຕົກລົງໄວ້ຕອນຈອງ',
  'New policy': 'ນະໂຍບາຍໃໝ່',
  'active policies': 'ນະໂຍບາຍທີ່ໃຊ້ງານ',
  'rate plans assigned': 'ແຜນລາຄາທີ່ກຳນົດແລ້ວ',
  'Default policy': 'ນະໂຍບາຍເລີ່ມຕົ້ນ',
  'None · free cancellation': 'ບໍ່ມີ · ຍົກເລີກຟຣີ',
  'No policy · free cancellation': 'ບໍ່ມີນະໂຍບາຍ · ຍົກເລີກຟຣີ',
  'Default cancellation policy saved': 'ບັນທຶກນະໂຍບາຍເລີ່ມຕົ້ນແລ້ວ',
  'No default policy. New reservations cancel free of charge unless their rate plan has a policy.':
    'ຍັງບໍ່ມີນະໂຍບາຍເລີ່ມຕົ້ນ. ການຈອງໃໝ່ຍົກເລີກໄດ້ຟຣີ ເວັ້ນເສຍແຕ່ແຜນລາຄາມີນະໂຍບາຍ',
  'Start with a proven policy': 'ເລີ່ມຈາກນະໂຍບາຍມາດຕະຖານ',
  'Pick a template to create your first policy. You can change fees, windows and terms before saving.':
    'ເລືອກແມ່ແບບເພື່ອສ້າງນະໂຍບາຍທຳອິດ. ທ່ານປ່ຽນຄ່າທຳນຽມ, ໄລຍະເວລາ ແລະ ເງື່ອນໄຂໄດ້ກ່ອນບັນທຶກ',
  Flexible: 'ຍືດຫຍຸ່ນ',
  Moderate: 'ປານກາງ',
  Strict: 'ເຂັ້ມງວດ',
  'Non-refundable': 'ບໍ່ຄືນເງິນ',
  'Free cancellation until 24 hours before arrival. Later cancellations are charged the first night. No-shows are charged the first night.':
    'ຍົກເລີກຟຣີຈົນຮອດ 24 ຊົ່ວໂມງກ່ອນເຂົ້າພັກ. ຍົກເລີກຫຼັງຈາກນັ້ນເກັບຄ່າຄືນທຳອິດ. ບໍ່ມາເຂົ້າພັກເກັບຄ່າຄືນທຳອິດ',
  'Free cancellation until 7 days before arrival. Within 7 days the first night is charged; within 24 hours, 50% of the stay. No-shows are charged the full stay.':
    'ຍົກເລີກຟຣີຈົນຮອດ 7 ມື້ກ່ອນເຂົ້າພັກ. ພາຍໃນ 7 ມື້ເກັບຄ່າຄືນທຳອິດ; ພາຍໃນ 24 ຊົ່ວໂມງເກັບ 50% ຂອງການພັກ. ບໍ່ມາເຂົ້າພັກເກັບເຕັມຈຳນວນ',
  'Free cancellation until 30 days before arrival. Within 30 days, 50% of the stay is charged; within 7 days, the full stay. No-shows are charged the full stay.':
    'ຍົກເລີກຟຣີຈົນຮອດ 30 ມື້ກ່ອນເຂົ້າພັກ. ພາຍໃນ 30 ມື້ເກັບ 50% ຂອງການພັກ; ພາຍໃນ 7 ມື້ເກັບເຕັມຈຳນວນ. ບໍ່ມາເຂົ້າພັກເກັບເຕັມຈຳນວນ',
  'The full stay is charged at booking and is not refunded on cancellation or no-show.':
    'ເກັບຄ່າການພັກເຕັມຈຳນວນຕອນຈອງ ແລະ ບໍ່ຄືນເງິນເມື່ອຍົກເລີກ ຫຼື ບໍ່ມາເຂົ້າພັກ',
  Default: 'ເລີ່ມຕົ້ນ',
  'rate plan': 'ແຜນລາຄາ',
  'rate plans': 'ແຜນລາຄາ',
  'No rate plans': 'ບໍ່ມີແຜນລາຄາ',
  'Make default': 'ຕັ້ງເປັນຄ່າເລີ່ມຕົ້ນ',
  'Edit policy': 'ແກ້ໄຂນະໂຍບາຍ',
  'Show archived policies': 'ສະແດງນະໂຍບາຍທີ່ຢຸດໃຊ້',
  'Fee windows count back from the standard check-in time on the arrival date. Fees are posted to the guest folio as unbilled charges, less room revenue already invoiced. Assign policies to rate plans in Rate plans & packages.':
    'ໄລຍະເວລານັບຖອຍຫຼັງຈາກເວລາເຊັກອິນມາດຕະຖານໃນວັນເຂົ້າພັກ. ຄ່າທຳນຽມຖືກບັນທຶກໃນບັນຊີແຂກເປັນລາຍການທີ່ຍັງບໍ່ອອກບິນ ຫັກລາຍຮັບຫ້ອງທີ່ອອກໃບແຈ້ງໜີ້ແລ້ວ. ກຳນົດນະໂຍບາຍໃຫ້ແຜນລາຄາໃນ ແຜນລາຄາ ແລະ ແພັກເກດ',
  'Cancellation reasons': 'ເຫດຜົນການຍົກເລີກ',
  'Cancellation reasons saved': 'ບັນທຶກເຫດຜົນການຍົກເລີກແລ້ວ',
  'Staff choose a reason when cancelling, so reports and the activity history stay consistent.':
    'ພະນັກງານເລືອກເຫດຜົນເມື່ອຍົກເລີກ ເພື່ອໃຫ້ລາຍງານ ແລະ ປະຫວັດສອດຄ່ອງກັນ',
  'Add reason': 'ເພີ່ມເຫດຜົນ',
  'No reasons yet. Staff type a reason each time they cancel.':
    'ຍັງບໍ່ມີເຫດຜົນ. ພະນັກງານພິມເຫດຜົນທຸກຄັ້ງທີ່ຍົກເລີກ',
  'Add suggested reasons': 'ເພີ່ມເຫດຜົນທີ່ແນະນຳ',
  'Change of plans': 'ປ່ຽນແຜນການເດີນທາງ',
  'Booked elsewhere': 'ຈອງບ່ອນອື່ນແລ້ວ',
  'Travel disruption': 'ການເດີນທາງມີບັນຫາ',
  'Illness or emergency': 'ເຈັບປ່ວຍ ຫຼື ເຫດສຸກເສີນ',
  'Duplicate booking': 'ຈອງຊ້ຳ',
  'Payment not received': 'ບໍ່ໄດ້ຮັບການຊຳລະ',
  'Hotel request': 'ໂຮງແຮມຮ້ອງຂໍ',
  'Reason name': 'ຊື່ເຫດຜົນ',
  Offered: 'ສະແດງ',
  Hidden: 'ເຊື່ອງໄວ້',
  'Remove reason': 'ລຶບເຫດຜົນ',
  'Give each reason a different name': 'ຕັ້ງຊື່ເຫດຜົນແຕ່ລະອັນໃຫ້ຕ່າງກັນ',
  'Unsaved reasons': 'ເຫດຜົນທີ່ຍັງບໍ່ໄດ້ບັນທຶກ',
  'Save reasons': 'ບັນທຶກເຫດຜົນ',
  'Hide a reason to stop offering it. Past cancellations keep the reason they recorded.':
    'ເຊື່ອງເຫດຜົນເພື່ອຢຸດໃຊ້. ການຍົກເລີກທີ່ຜ່ານມາຍັງເກັບເຫດຜົນເດີມໄວ້',
  'No fee': 'ບໍ່ເກັບຄ່າທຳນຽມ',
  '% of the stay': '% ຂອງການພັກ',
  Nights: 'ຈຳນວນຄືນ',
  'Fixed amount (LAK)': 'ຈຳນວນຄົງທີ່ (ກີບ)',
  'Fee type': 'ປະເພດຄ່າທຳນຽມ',
  'Fee amount': 'ຈຳນວນຄ່າທຳນຽມ',
  'Edit cancellation policy': 'ແກ້ໄຂນະໂຍບາຍການຍົກເລີກ',
  'New cancellation policy': 'ນະໂຍບາຍການຍົກເລີກໃໝ່',
  'Changes apply to new reservations. Existing reservations keep the terms they were booked with.':
    'ການປ່ຽນແປງໃຊ້ກັບການຈອງໃໝ່. ການຈອງທີ່ມີຢູ່ແລ້ວໃຊ້ເງື່ອນໄຂເດີມ',
  'Cancellation policy saved': 'ບັນທຶກນະໂຍບາຍການຍົກເລີກແລ້ວ',
  'Cancellation policy added': 'ເພີ່ມນະໂຍບາຍການຍົກເລີກແລ້ວ',
  Templates: 'ແມ່ແບບ',
  'Start from': 'ເລີ່ມຈາກ',
  'Policy details': 'ລາຍລະອຽດນະໂຍບາຍ',
  'Policy name': 'ຊື່ນະໂຍບາຍ',
  'Guest-facing terms': 'ເງື່ອນໄຂສຳລັບແຂກ',
  'Write from fee tiers': 'ຂຽນຈາກຂັ້ນຄ່າທຳນຽມ',
  'Charge the full stay whenever the guest cancels or does not arrive.':
    'ເກັບຄ່າການພັກເຕັມຈຳນວນເມື່ອແຂກຍົກເລີກ ຫຼື ບໍ່ມາເຂົ້າພັກ',
  'Cancellation fees': 'ຄ່າທຳນຽມການຍົກເລີກ',
  'Before these windows, cancellation is free.': 'ກ່ອນໄລຍະເວລາເຫຼົ່ານີ້ ຍົກເລີກໄດ້ຟຣີ',
  'Cancelled within': 'ຍົກເລີກພາຍໃນ',
  Window: 'ໄລຍະເວລາ',
  'Window unit': 'ຫົວໜ່ວຍເວລາ',
  hours: 'ຊົ່ວໂມງ',
  hour: 'ຊົ່ວໂມງ',
  day: 'ມື້',
  'of arrival, charge': 'ກ່ອນເຂົ້າພັກ, ເກັບ',
  Tier: 'ຂັ້ນ',
  'Remove tier': 'ລຶບຂັ້ນ',
  'Add fee tier': 'ເພີ່ມຂັ້ນຄ່າທຳນຽມ',
  'Each fee tier needs a different cancellation window': 'ແຕ່ລະຂັ້ນຄ່າທຳນຽມຕ້ອງມີໄລຍະເວລາຕ່າງກັນ',
  'Choose a window up to 365 days before arrival': 'ເລືອກໄລຍະເວລາບໍ່ເກີນ 365 ມື້ກ່ອນເຂົ້າພັກ',
  'No-show fee': 'ຄ່າທຳນຽມບໍ່ມາເຂົ້າພັກ',
  'Charged when the guest does not arrive and the booking is marked no-show.':
    'ເກັບເມື່ອແຂກບໍ່ມາເຂົ້າພັກ ແລະ ການຈອງຖືກໝາຍວ່າບໍ່ມາເຂົ້າພັກ',
  'Enter 1–100% of the stay, 1–30 nights, or a whole LAK amount':
    'ປ້ອນ 1–100% ຂອງການພັກ, 1–30 ຄືນ ຫຼື ຈຳນວນກີບເຕັມ',
  'Example: 3 nights at': 'ຕົວຢ່າງ: 3 ຄືນ ລາຄາ',
  'Choose another default policy before archiving this one.':
    'ເລືອກນະໂຍບາຍເລີ່ມຕົ້ນອື່ນກ່ອນຢຸດໃຊ້ນະໂຍບາຍນີ້',
  'Turn off to archive. Reservations already booked keep these terms.':
    'ປິດເພື່ອຢຸດໃຊ້. ການຈອງທີ່ມີແລ້ວຍັງໃຊ້ເງື່ອນໄຂນີ້',
  'Save policy': 'ບັນທຶກນະໂຍບາຍ',
  'Add policy': 'ເພີ່ມນະໂຍບາຍ',
  Free: 'ຟຣີ',
  'of the stay': 'ຂອງການພັກ',
  'After the arrival time': 'ຫຼັງເວລາເຂົ້າພັກ',
  Within: 'ພາຍໃນ',
  'of arrival': 'ກ່ອນເຂົ້າພັກ',
  'Non-refundable. The full stay is charged on cancellation or no-show.':
    'ບໍ່ຄືນເງິນ. ເກັບຄ່າການພັກເຕັມຈຳນວນເມື່ອຍົກເລີກ ຫຼື ບໍ່ມາເຂົ້າພັກ',
  'Free cancellation until': 'ຍົກເລີກຟຣີຈົນຮອດ',
  'before arrival.': 'ກ່ອນເຂົ້າພັກ.',
  'Free cancellation at any time before arrival.': 'ຍົກເລີກຟຣີໄດ້ທຸກເວລາກ່ອນເຂົ້າພັກ',
  'Any time': 'ທຸກເວລາ',
  'Earlier than': 'ກ່ອນ',
  'Before arrival': 'ກ່ອນເຂົ້າພັກ',
  'Cancellation fees before arrival': 'ຄ່າທຳນຽມການຍົກເລີກກ່ອນເຂົ້າພັກ',
  'Free cancellation': 'ຍົກເລີກຟຣີ',
  'Cancellation fee applies now': 'ຕອນນີ້ມີຄ່າທຳນຽມການຍົກເລີກ',
  Change: 'ປ່ຽນ',
  'Cancel now': 'ຍົກເລີກຕອນນີ້',
  Now: 'ຕອນນີ້',
  'New terms': 'ເງື່ອນໄຂໃໝ່',
  'Reason for changing the agreed terms': 'ເຫດຜົນທີ່ປ່ຽນເງື່ອນໄຂທີ່ຕົກລົງໄວ້',
  'Update terms': 'ອັບເດດເງື່ອນໄຂ',
  'Cancellation terms updated': 'ອັບເດດເງື່ອນໄຂການຍົກເລີກແລ້ວ',
  'No cancellation policy applies to this booking.': 'ການຈອງນີ້ບໍ່ມີນະໂຍບາຍການຍົກເລີກ',
  'Cancelled before every fee window, so no fee applies.':
    'ຍົກເລີກກ່ອນທຸກໄລຍະທີ່ມີຄ່າທຳນຽມ ຈຶ່ງບໍ່ມີຄ່າທຳນຽມ',
  'No-show fee under the agreed policy.': 'ຄ່າທຳນຽມບໍ່ມາເຂົ້າພັກຕາມນະໂຍບາຍທີ່ຕົກລົງ',
  'Non-refundable: the full stay is charged.': 'ບໍ່ຄືນເງິນ: ເກັບຄ່າການພັກເຕັມຈຳນວນ',
  'Agreed policy': 'ນະໂຍບາຍທີ່ຕົກລົງ',
  None: 'ບໍ່ມີ',
  'Room total': 'ຄ່າຫ້ອງທັງໝົດ',
  'Policy penalty': 'ຄ່າປັບຕາມນະໂຍບາຍ',
  'Already billed room revenue': 'ຄ່າຫ້ອງທີ່ອອກບິນແລ້ວ',
  'Policy fee': 'ຄ່າທຳນຽມຕາມນະໂຍບາຍ',
  'Calculating the policy fee…': 'ກຳລັງຄິດໄລ່ຄ່າທຳນຽມ…',
  Fee: 'ຄ່າທຳນຽມ',
  'Charge policy fee': 'ເກັບຄ່າທຳນຽມຕາມນະໂຍບາຍ',
  'No fee under the policy': 'ນະໂຍບາຍບໍ່ມີຄ່າທຳນຽມ',
  'Posted to the guest folio as an unbilled charge.': 'ບັນທຶກໃນບັນຊີແຂກເປັນລາຍການທີ່ຍັງບໍ່ອອກບິນ',
  'Waive the fee': 'ຍົກເວັ້ນຄ່າທຳນຽມ',
  'Requires a manager. Recorded with your reason.': 'ຕ້ອງເປັນຜູ້ຈັດການ. ບັນທຶກພ້ອມເຫດຜົນ',
  'Charge a different amount': 'ເກັບຈຳນວນອື່ນ',
  'Fee amount (LAK)': 'ຈຳນວນຄ່າທຳນຽມ (ກີບ)',
  'Choose a reason': 'ເລືອກເຫດຜົນ',
  'Other reason': 'ເຫດຜົນອື່ນ',
  'Details (optional)': 'ລາຍລະອຽດ (ບໍ່ບັງຄັບ)',
  'Explain why the policy fee was changed.': 'ອະທິບາຍວ່າເປັນຫຍັງຈຶ່ງປ່ຽນຄ່າທຳນຽມ',
  'Apply it to the fee or refund it through LFB receipts.':
    'ນຳໄປຫັກຄ່າທຳນຽມ ຫຼື ຄືນເງິນຜ່ານໃບຮັບເງິນ LFB',
  'Cancel and charge': 'ຍົກເລີກ ແລະ ເກັບ',
  'Mark no-show and charge': 'ໝາຍບໍ່ມາເຂົ້າພັກ ແລະ ເກັບ',
  'Rate plan policy': 'ນະໂຍບາຍຂອງແຜນລາຄາ',
  'Property default': 'ຄ່າເລີ່ມຕົ້ນຂອງໂຮງແຮມ',
  'No policy': 'ບໍ່ມີນະໂຍບາຍ',
  'New bookings on this plan accept these terms.': 'ການຈອງໃໝ່ໃນແຜນນີ້ໃຊ້ເງື່ອນໄຂນີ້',
  'Cancellation terms changed': 'ປ່ຽນເງື່ອນໄຂການຍົກເລີກ',
  'Charged under the policy': 'ເກັບຕາມນະໂຍບາຍ',
  'Waived by a manager': 'ຜູ້ຈັດການຍົກເວັ້ນ',
  'Changed by a manager': 'ຜູ້ຈັດການປ່ຽນຈຳນວນ',
  'Fee posted': 'ຄ່າທຳນຽມທີ່ບັນທຶກ',
  policy: 'ນະໂຍບາຍ',
  'Fee released': 'ຍົກເລີກຄ່າທຳນຽມແລ້ວ',
  'A cancellation policy already uses this name': 'ມີນະໂຍບາຍການຍົກເລີກໃຊ້ຊື່ນີ້ແລ້ວ',
  'Choose another default cancellation policy before archiving this one':
    'ເລືອກນະໂຍບາຍເລີ່ມຕົ້ນອື່ນກ່ອນຢຸດໃຊ້ນະໂຍບາຍນີ້',
  'Choose an active default cancellation policy': 'ເລືອກນະໂຍບາຍເລີ່ມຕົ້ນທີ່ໃຊ້ງານຢູ່',
  'Choose an active cancellation policy': 'ເລືອກນະໂຍບາຍການຍົກເລີກທີ່ໃຊ້ງານຢູ່',
  'Choose an active cancellation reason': 'ເລືອກເຫດຜົນການຍົກເລີກທີ່ໃຊ້ງານຢູ່',
  'Cancellation terms can change only before arrival':
    'ປ່ຽນເງື່ອນໄຂການຍົກເລີກໄດ້ກ່ອນເຂົ້າພັກເທົ່ານັ້ນ',
  'A hotel can have up to 50 cancellation policies': 'ໂຮງແຮມມີນະໂຍບາຍການຍົກເລີກໄດ້ສູງສຸດ 50 ອັນ',
  'Cancellation policy not found': 'ບໍ່ພົບນະໂຍບາຍການຍົກເລີກ',
  'Fees apply to cancellation and no-show only':
    'ຄ່າທຳນຽມໃຊ້ກັບການຍົກເລີກ ແລະ ບໍ່ມາເຂົ້າພັກເທົ່ານັ້ນ',
};
